import Axios from 'axios';
import { config } from '../utils';

export const axiosInstance = Axios.create({
  baseURL: config.apiBaseUrl,
  timeout: 10000,
});
